var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01 19.01C7.01 20.11 7.9 21 9 21C10.1 21 10.99 20.11 10.99 19.01H7.01ZM15.88 14.82V9C15.88 5.75 13.63 3.03 10.59 2.31V1.59C10.59 0.71 9.88 0 9 0C8.12 0 7.41 0.71 7.41 1.59V2.31C4.37 3.03 2.12 5.75 2.12 9V14.82L0 16.94V18H18V16.94L15.88 14.82ZM13 11.01H10V14.01H8V11.01H5V9H8V6H10V9H13V11.01Z",
    fill: "#DB3627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnBell);
export default __webpack_public_path__ + "static/media/warn-bell.070c9475200585bfb948b989fb85b201.svg";
export { ForwardRef as ReactComponent };